export function debounce(fn, ms) {
	let id;
	return (...args) => {
		clearTimeout(id);
		id = setTimeout(() => fn(...args), ms);
	};
}

export function escapeHtml(str) {
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}
